import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=3ff15f57&scoped=true"
import script from "./UserSignup.vue?vue&type=script&lang=js"
export * from "./UserSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff15f57",
  null
  
)

export default component.exports